import { L10n } from '@syncfusion/ej2-base'

export const loadLocalization = () => {
  L10n.load({
    de: {
      daterangepicker: {
        placeholder: 'Wählen Sie einen Bereich aus',
        startLabel: 'Startdatum',
        endLabel: 'Enddatum',
        applyText: 'Übernehmen',
        cancelText: 'Abbrechen',
        selectedDays: 'Ausgewählte Tage',
        days: 'Tage',
        customRange: 'eigener Bereich',
      },
      grid: {
        Add: 'Hinzufügen',
        Edit: 'Bearbeiten',
        Cancel: 'Abbrechen',
        Update: 'Speichern',
        Delete: 'Löschen',
        Print: 'Drucken',
        EditOperationAlert: 'Bitte eine Zeile auswählen.',
        DeleteOperationAlert: 'Bitte eine Zeile auswählen.',
        SaveButton: 'Speichern',
        EmptyRecord: 'Keine Daten vorhanden',
        GroupDropArea: 'Ziehen Sie einen Spaltenkopf hier, um die Gruppe ihre Spalte',
        UnGroup: 'Klicken Sie hier, um die Gruppierung aufheben',
        EmptyDataSourceError: 'DataSource darf bei der Erstauslastung nicht leer sein, da Spalten aus der dataSource im AutoGenerate Spaltenraster',
        Item: 'Artikel',
        Items: 'Artikel',
        True: 'Ja',
        False: 'Nein',
        SelectAll: 'Alle auswählen',
        Columnchooser: 'Spalten wählen',
        ChooseColumns: 'Spalten wählen',
        ColumnChooserDialogARIA: 'Spalten wählen',
        Search: 'Suchen',
        CancelButton: 'Abbrechen',
        FilterbarTitle: ': Filter Eingabefeld',
        Clear: 'Löschen',
        ClearFilter: 'Löschen',
        ClearButton: 'Löschen',
      },
      pager: {
        currentPageInfo: '{0} von {1} Seiten',
        totalItemsInfo: '({0} Einträge)',
        firstPageTooltip: 'Gehe zur ersten Seite',
        lastPageTooltip: 'Gehe zur letzten Seite',
        nextPageTooltip: 'Gehe zur nächsten Seite',
        previousPageTooltip: 'Zurück zur letzten Seite',
        nextPagerTooltip: 'Gehe zu den nächsten Pager-Elementen',
        previousPagerTooltip: 'Gehen Sie zu den vorherigen Pager-Elementen',
        pagerDropDown: 'Datensätze pro Seite',
        pagerAllDropDown: 'Datensätze',
        All: 'Alle',
        totalItemInfo: '({0} Einträge)',
        Container: 'Pager-Container',
        Information: 'Pager-Informationen',
        ExternalMsg: 'Pager-externe Nachricht',
        Page: 'Buchseite ',
        Of: ' von ',
        Pages: ' Seiten',
      },
      numerictextbox: { incrementTitle: 'Wert erhöhen', decrementTitle: 'Wert verringern' },
      schedule: {
        day: 'Tag',
        week: 'Woche',
        workWeek: 'Arbeitswoche',
        month: 'Monat',
        agenda: 'Agenda',
        weekAgenda: 'Wochen Agenda',
        workWeekAgenda: 'Arbeitswoche Agenda',
        monthAgenda: 'Monats Agenda',
        today: 'Heute',
        noEvents: 'Keine Veranstaltungen',
        previous: 'Zurück',
        next: 'Vor',
        more: 'weiteres',
        allDay: 'Ganztägig',
        close: 'Schließen',
        edit: 'Bearbeiten',
        delete: 'Löschen',
        timelineDay: 'Tagesansicht',
        timelineWeek: 'Wochenansicht',
      },
      datepicker: {
        placeholder: 'Wählen Sie ein Datum',
        today: 'heute',
      },
      calendar: {
        today: 'Heute',
      },
      'multi-select': {
        overflowCountTemplate: '+${count} weitere...',
        selectAllText: 'Alle auswählen',
        unSelectAllText: 'Keine auswählen',
        noRecordsTemplate: 'Keine Daten vorhanden',
        actionFailureTemplate: 'Die Anfrage ist fehlgeschlagen',
      },
      dropdowns: {
        actionFailureTemplate: 'Die Anfrage ist fehlgeschlagen',
        noRecordsTemplate: 'Keine Daten gefunden',
      },
      formValidator: {
        required: 'Dieses Feld ist erforderlich.',
        email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
        url: 'Bitte geben Sie eine gültige URL ein.',
        date: 'Bitte geben Sie ein gültiges Datum ein.',
        dateIso: 'Bitte geben Sie ein gültiges Datum (ISO) ein.',
        number: 'Bitte geben Sie eine gültige Zahl ein.',
        digit: 'Geben Sie bitte nur Ziffern ein.',
        maxLength: 'Bitte geben Sie nicht mehr als {0} Zeichen ein.',
        minLength: 'Bitte geben Sie mindestens {0} Zeichen ein.',
        rangeLength: 'Bitte geben Sie einen Wert zwischen {0} und {1} Zeichen lang ein.',
        range: 'Bitte geben Sie einen Wert zwischen {0} und {1} ein.',
        max: 'Bitte geben Sie einen Wert kleiner oder gleich {0} ein.',
        min: 'Bitte geben Sie einen Wert größer oder gleich {0} ein.',
        regex: 'Bitte geben Sie einen korrekten Wert ein.',
      },
      uploader: {
        Browse: 'Durchsuchen',
        Clear: 'Löschen',
        Upload: 'Hochladen',
        cancel: 'Abbrechen',
        abort: 'Abbrechen',
        delete: 'Datei löschen',
        totalFiles: 'Gesamtzahl der Dateien',
        size: 'Größe',
        dropFilesHint: 'oder Datei hier ablegen',
        inProgress: 'Wird geladen',
        invalidFileType: 'Der Dateityp ist nicht erlaubt',
        invalidMaxFileSize: 'Die Dateigröße überschreitet 28 MB',
        invalidMinFileSize: 'Die Dateigröße ist zu klein! Bitte laden Sie Dateien mit einer Mindestgröße von 10 KB hoch',
        readyToUploadMessage: 'Bereit zum Hochladen',
        remove: 'Entfernen',
        removedFailedMessage: 'Die Datei konnte nicht gelöscht werden',
        removedSuccessMessage: 'Datei erfolgreich gelöscht',
        uploadFailedMessage: 'Importieren der Datei fehlgeschlagen',
        uploadSuccessMessage: 'Datei erfolgreich hochgeladen',
        retry: 'Wiederholen',
        fileUploadCancel: 'Dateiupload abgebrochen',
      },
      richtexteditor: {
        alignments: 'Ausrichtungen',
        justifyLeft: 'Linksbündig',
        justifyCenter: 'Zentriert',
        justifyRight: 'Rechtsbündig',
        justifyFull: 'Blocksatz',
        fontName: 'Schriftart',
        fontSize: 'Schriftgröße',
        fontColor: 'Schriftfarbe',
        backgroundColor: 'Hintergrundfarbe',
        bold: 'Fett',
        italic: 'Kursiv',
        underline: 'Unterstrichen',
        strikethrough: 'Durchgestrichen',
        clearFormat: 'Formatierung löschen',
        clearAll: 'Alles löschen',
        cut: 'Ausschneiden',
        copy: 'Kopieren',
        paste: 'Einfügen',
        unorderedList: 'Ungeordnete Liste',
        orderedList: 'Nummerierte Liste',
        indent: 'Einzug erhöhen',
        outdent: 'Einzug verringern',
        undo: 'Rückgängig',
        redo: 'Wiederholen',
        superscript: 'Hochgestellt',
        subscript: 'Tiefgestellt',
        createLink: 'Link einfügen',
        openLink: 'Link öffnen',
        editLink: 'Link bearbeiten',
        removeLink: 'Link entfernen',
        image: 'Bild einfügen',
        replace: 'Ersetzen',
        align: 'Ausrichten',
        caption: 'Bildunterschrift',
        remove: 'Entfernen',
        insertLink: 'Link einfügen',
        display: 'Anzeige',
        altText: 'Alternativtext',
        dimension: 'Größe ändern',
        fullscreen: 'Vollbild',
        maximize: 'Maximieren',
        minimize: 'Minimieren',
        lowerCase: 'Kleinbuchstaben',
        upperCase: 'Großbuchstaben',
        print: 'Drucken',
        formats: 'Formate',
        sourcecode: 'Quellcode-Ansicht',
        preview: 'Vorschau',
        viewside: 'Seitenansicht',
        insertCode: 'Code einfügen',
        linkText: 'Anzeigetext',
        linkTooltipLabel: 'Titel',
        linkWebUrl: 'Webadresse',
        linkTitle: 'Einen Titel eingeben',
        linkurl: '',
        linkOpenInNewWindow: 'Link in neuem Fenster öffnen',
        linkHeader: 'Link einfügen',
        dialogInsert: 'Einfügen',
        dialogCancel: 'Abbrechen',
        dialogUpdate: 'Aktualisieren',
        imageHeader: 'Bild einfügen',
        imageLinkHeader: 'Sie können auch einen Link aus dem Web angeben',
        mdimageLink: 'Bitte geben Sie eine URL für Ihr Bild an',
        imageUploadMessage: 'Bild hierher ziehen oder zum Hochladen durchsuchen',
        imageDeviceUploadMessage: 'Hier klicken zum Hochladen',
        imageAlternateText: 'Alternativtext',
        alternateHeader: 'Alternativtext',
        browse: 'Durchsuchen',
        imageUrl: 'http://beispiel.com/bild.png',
        imageCaption: 'Bildunterschrift',
        imageSizeHeader: 'Bildgröße',
        imageHeight: 'Höhe',
        imageWidth: 'Breite',
        textPlaceholder: 'Text eingeben',
        inserttablebtn: 'Tabelle einfügen',
        tabledialogHeader: 'Tabelle einfügen',
        tableWidth: 'Breite',
        cellpadding: 'Zellenabstand',
        cellspacing: 'Zellabstand',
        columns: 'Anzahl der Spalten',
        rows: 'Anzahl der Zeilen',
        tableRows: 'Tabellenzeilen',
        tableColumns: 'Tabellenspalten',
        tableCellHorizontalAlign: 'Zellenhorizontale Ausrichtung',
        tableCellVerticalAlign: 'Zellenvertikale Ausrichtung',
        createTable: 'Tabelle erstellen',
        removeTable: 'Tabelle entfernen',
        tableHeader: 'Tabellenkopf',
        tableRemove: 'Tabelle entfernen',
        tableCellBackground: 'Zellenhintergrund',
        tableEditProperties: 'Tabelleneigenschaften bearbeiten',
        styles: 'Stile',
        insertColumnLeft: 'Spalte links einfügen',
        insertColumnRight: 'Spalte rechts einfügen',
        deleteColumn: 'Spalte löschen',
        insertRowBefore: 'Zeile davor einfügen',
        insertRowAfter: 'Zeile danach einfügen',
        deleteRow: 'Zeile löschen',
        tableEditHeader: 'Tabelle bearbeiten',
        TableHeadingText: 'Überschrift',
        TableColText: 'Spalte',
        imageInsertLinkHeader: 'Link einfügen',
        editImageHeader: 'Bild bearbeiten',
        alignmentsDropDownLeft: 'Linksbündig',
        alignmentsDropDownCenter: 'Zentriert',
        alignmentsDropDownRight: 'Rechtsbündig',
        alignmentsDropDownJustify: 'Blocksatz',
        imageDisplayDropDownInline: 'Inline',
        imageDisplayDropDownBreak: 'Umbruch',
        tableInsertRowDropDownBefore: 'Zeile davor einfügen',
        tableInsertRowDropDownAfter: 'Zeile danach einfügen',
        tableInsertRowDropDownDelete: 'Zeile löschen',
        tableInsertColumnDropDownLeft: 'Spalte links einfügen',
        tableInsertColumnDropDownRight: 'Spalte rechts einfügen',
        tableInsertColumnDropDownDelete: 'Spalte löschen',
        tableVerticalAlignDropDownTop: 'Oben ausrichten',
        tableVerticalAlignDropDownMiddle: 'Mittig ausrichten',
        tableVerticalAlignDropDownBottom: 'Unten ausrichten',
        tableStylesDropDownDashedBorder: 'Gestrichelte Ränder',
        tableStylesDropDownAlternateRows: 'Alternierende Reihen',
        pasteFormat: 'Format einfügen',
        pasteFormatContent: 'Wählen Sie die Aktion zur Formatierung',
        plainText: 'Nur Text',
        cleanFormat: 'Säubern',
        keepFormat: 'Format beibehalten',
        pasteDialogOk: 'OK',
        pasteDialogCancel: 'Abbrechen',
        fileManager: 'Dateimanager',
        fileDialogHeader: 'Dateibrowser',
        formatsDropDownParagraph: 'Absatz',
        formatsDropDownCode: 'Code',
        formatsDropDownQuotation: 'Zitat',
        formatsDropDownHeading1: 'Überschrift 1',
        formatsDropDownHeading2: 'Überschrift 2',
        formatsDropDownHeading3: 'Überschrift 3',
        formatsDropDownHeading4: 'Überschrift 4',
        fontNameSegoeUI: 'Segoe UI',
        fontNameArial: 'Arial',
        fontNameGeorgia: 'Georgia',
        fontNameImpact: 'Impact',
        fontNameTahoma: 'Tahoma',
        fontNameTimesNewRoman: 'Times New Roman',
        fontNameVerdana: 'Verdana',
        numberFormatListNumber: 'Nummer',
        numberFormatListLowerAlpha: 'Kleinbuchstaben',
        numberFormatListUpperAlpha: 'Großbuchstaben',
        numberFormatListLowerRoman: 'Kleinrömisch',
        numberFormatListUpperRoman: 'Großrömisch',
        numberFormatListLowerGreek: 'Kleingriechisch',
        bulletFormatListDisc: 'Scheibe',
        bulletFormatListCircle: 'Kreis',
        bulletFormatListSquare: 'Quadrat',
        numberFormatListNone: 'Keine',
        bulletFormatListNone: 'Keine',
        formatPainter: 'Formatierungsüberträger',
        emojiPicker: 'Emoji-Auswahl',
        embeddedCode: 'Eingebetteter Code',
        pasteEmbeddedCodeHere: 'Eingebetteten Code hier einfügen',
        emojiPickerTypeToFind: 'Tippen, um zu suchen',
        emojiPickerNoResultFound: 'Keine Ergebnisse gefunden',
        emojiPickerTrySomethingElse: 'Versuchen Sie etwas anderes',
      },
      dialog: {
        close: 'Schließen',
      },
    },
  })
}
